// extracted by mini-css-extract-plugin
export var dividerLine = "_7m-3";
export var itemImage = "_7m-9";
export var lightDivider = "_7m-4";
export var modalContent = "_7m-5";
export var modalContentCompact = "_7m-6";
export var productCard = "_7m-a";
export var productImage = "_7m-b";
export var productImageCompact = "_7m-7";
export var productImagePlaceholder = "_7m-c";
export var productImagePlaceholderCompact = "_7m-8";
export var progressBarBackground = "_7m-1";
export var progressBarContainer = "_7m-0";
export var progressBarFill = "_7m-2";